import React, {Component} from 'react';
import DefaultLayout from "../../components/DefaultLayout";

class NotFound extends Component {
    render() {
        return (
        <div className='App-block'>
            <DefaultLayout {...this.props} title="404 notfound" page_type={1} hiddenFt={true} showBottomPanel={false}>
            <div className="wrap-content">
                <div>404 notfound</div>
            </div>
            </DefaultLayout>
        </div>
        )
    }
}

export default NotFound;